import { optionalValueCellFactory } from './optionalValue'

import classes from './Simple.module.scss'

const AVERAGE_REACH_FORMAT = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
})

export const AverageReachCell = optionalValueCellFactory((value: number) =>
    AVERAGE_REACH_FORMAT.format(value)
)

const ERR_FORMAT = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
})

export const ErrCell = optionalValueCellFactory(
    (value: number) => ERR_FORMAT.format(value) + '%'
)

const DATE_FORMAT = new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
})

const TIME_FORMAT = new Intl.DateTimeFormat('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
})

export const ReachCell = optionalValueCellFactory((value: number) =>
    value.toString()
)

export const CreationDateCell = ({ children }: { children: Date }) => {
    return <div className="">{DATE_FORMAT.format(children)}</div>
}

export const DateWithTimeCell = optionalValueCellFactory((value: Date) => {
    return (
        <div className={classes.dateWithTime}>
            <div>{DATE_FORMAT.format(value)}</div>
            <div className={classes.time}>{TIME_FORMAT.format(value)}</div>
        </div>
    )
})

export const CpmCell = ({ children: value }: { children: number }) => {
    return <div className={classes.cpm}>{`${(value * 1000).toFixed(0)} ₽`}</div>
}
